/**
 * Agrupación por TIPO del centro de notificaciones (referencia MySchoolUAE: pestañas por
 * categoría con contador, no por estado leído/no leído).
 *
 * Los tipos son los del PAYLOAD (`data.type`), no la clase de la notificación: el backend
 * filtra por ellos con el argumento `types` de la query `notifications`.
 */

export const NEWS_TYPES = ['news.created', 'news.updated'];

export const RANKING_TYPES = [
  'rank_up',
  'top_3_monthly',
  // Clave antigua: hay notificaciones guardadas con ella.
  'top3_monthly',
  'weekly_summary',
  'reward_approved',
  'admin_top3_approval',
  'play.result_reviewed',
  'progress.improved'
];

/** `types: null` = sin filtro (pestaña "Todas"). */
export const NOTIFICATION_GROUPS = [
  { key: 'all', types: null, labelKey: 'groups.all', defaultLabel: 'Todas' },
  { key: 'news', types: NEWS_TYPES, labelKey: 'groups.news', defaultLabel: 'Noticias' },
  { key: 'ranking', types: RANKING_TYPES, labelKey: 'groups.ranking', defaultLabel: 'Ranking' }
];

/** Suma los contadores por tipo que devuelve `notificationTypeCounts` para un grupo. */
export const countForGroup = (typeCounts, group) => {
  const rows = typeCounts || [];
  if (!group.types) return rows.reduce((acc, r) => acc + (r.total || 0), 0);
  return rows.reduce((acc, r) => (group.types.includes(r.type) ? acc + (r.total || 0) : acc), 0);
};

export default NOTIFICATION_GROUPS;
